import { createAsyncThunk } from '@reduxjs/toolkit';

import { NewsService } from 'api';

import { GetNewsProps } from 'models';

export const getNewsTitlesMore = createAsyncThunk(
	'news/getNewsTitlesMore',
	async (params: GetNewsProps) => {
		return await NewsService.getTitles(params);
	},
);
